export default __webpack_public_path__ + "static/media/remove-new.646d9d54.svg";